import { I18n } from "i18n-js"

const i18nInstance = new I18n()
i18nInstance.defaultLocale = "de"
i18nInstance.locale = "de"

export default i18nInstance
